import { PriceFreezeExerciseDiscountUpdate } from "@b2bportal/price-freeze-api";
import { Payment, PaymentOpaqueValue } from "@b2bportal/purchase-api";
import { FlightContext } from "@checkout/index";
import { PartialParentContext, ParentState } from "@checkout/types";
import { RequiredField } from "@hopper-b2b/utilities";

export interface AirPriceFreezeExerciseDiscount extends PaymentOpaqueValue {
  type: typeof Payment.AirPriceFreezeExerciseDiscount;
  value: PriceFreezeExerciseDiscountUpdate;
}

export enum PriceFreezeState {
  route = "route",
  initialize = "initialize",
  addDiscount = "addDiscount",
  error = "error",
}

export interface ParentContextWithPF
  extends PartialParentContext,
    FlightContext {}
